import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const RedoIcon = forwardRef(({ title = 'Redo Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 16 14" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M1.6 9.84a7 7 0 0 0 9.97 3.18.5.5 0 0 0 .14-.72l-.57-.82a.5.5 0 0 0-.67-.13 5 5 0 1 1 1.25-7.69L9.48 5.9c-.32.33-.1.88.37.88h5.41c.29 0 .52-.23.52-.52V.85a.51.51 0 0 0-.88-.37l-1.76 1.77A7.02 7.02 0 0 0 1.6 9.84" })));
});
//# sourceMappingURL=redo_icon.js.map